import styled from "styled-components";

export const Container = styled.div<{ showTimer?: boolean }>(({ theme, showTimer }) => ({
    flex: 1,
    marginRight: showTimer ? theme.spacing.xxSmall : theme.spacing.xLarge,
    position: "relative",
}));
